import React from "react";
import { getIn, useFormikContext } from "formik";
import { withNamespace } from "components/Form/FormikControls";
import Grid from "@material-ui/core/Grid";
import { SlimButton, SlimSecondaryButton } from "components/Button";
import { EmailRecipientsTable } from "./EmailRecipientsTable";
import { EmailRecipientFormSection } from "./EmailRecipientForm";

interface EmailRecipientsPanelProps {
  masterBusinessId: string;
  primaryContactEmail: string | null;
  namespace: string;
  onEndEditing: () => void;
  onStartEditing: () => void;
  onSetPrimaryContactEmail: (email: string) => void;
}

export function EmailRecipientsPanel(
  props: EmailRecipientsPanelProps,
): React.JSX.Element {
  const {
    masterBusinessId: businessId, // TODO - rename to businessId, and deprecate the master prefix.
    primaryContactEmail,
    namespace: ns,
    onEndEditing,
    onStartEditing,
    onSetPrimaryContactEmail,
  } = props;
  const formikContext = useFormikContext();
  const { values, dirty, isValid } = formikContext;

  // Get the current Specific Business's EmailRecipients from the Formik state
  const editingEmailRecipient = getIn(
    values,
    withNamespace(ns, "editingValue"),
  ) as EmailRecipient | null | undefined;

  const isRevertEnabled = dirty;

  const isSubmitEnabled = dirty && isValid && editingEmailRecipient === null;

  return (
    <>
      <EmailRecipientFormSection
        namespace={ns}
        onSetPrimaryContactEmail={onSetPrimaryContactEmail}
      />

      <EmailRecipientsTable
        businessId={businessId}
        primaryContactEmail={primaryContactEmail}
        namespace={ns}
        onEndEditing={onEndEditing}
        onStartEditing={onStartEditing}
        onSetPrimaryContactEmail={onSetPrimaryContactEmail}
      />

      <Grid container spacing={2} alignItems="flex-end">
        <Grid container item xs={12}>
          <SlimSecondaryButton type="reset" disabled={!isRevertEnabled}>
            Revert Changes
          </SlimSecondaryButton>
          <SlimButton
            type="submit"
            disabled={!isSubmitEnabled}
            data-tour="emailSubmit"
          >
            Accept Changes
          </SlimButton>
        </Grid>
      </Grid>
    </>
  );
}
